import { render } from "./Brand.vue?vue&type=template&id=0a0ef352&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=0a0ef352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0ef352"],['__file',"src/components/layout/Brand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a0ef352"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a0ef352', __exports__)) {
    api.reload('0a0ef352', __exports__)
  }
  
  module.hot.accept("./Brand.vue?vue&type=template&id=0a0ef352&scoped=true", () => {
    api.rerender('0a0ef352', render)
  })

}


export default __exports__